export const SENTRY_DEFAULTS = {
  dsn: 'https://78eeb87b9b5b0edc866a696a0f59571a@sentry.webexpertbusiness.com/12',
  org: 'webexpertbusiness',
  project: 'demand-planning-app',
  url: 'https://sentry.webexpertbusiness.com/',
};
